type NewLocale = "fr" | "it" | "es" | "pt" | "el" | "nl";
type LocalePaths = Record<NewLocale, string>;

const route = (
  fr: string,
  it: string,
  es: string,
  pt: string,
  el: string,
  nl: string
): LocalePaths => ({
  fr: `/${fr}`,
  it: `/${it}`,
  es: `/${es}`,
  pt: `/${pt}`,
  el: `/${el}`,
  nl: `/${nl}`,
});

const pathnames: Record<string, LocalePaths> = {
  "/sammenligning": route(
    "comparatif",
    "confronto",
    "comparativa",
    "comparacao",
    "σύγκριση",
    "vergelijking"
  ),
  "/how-to-use-qr-codes": route(
    "comment-utiliser-les-codes-qr",
    "come-usare-i-codici-qr",
    "como-usar-codigos-qr",
    "como-usar-codigos-qr",
    "πώς-να-χρησιμοποιήσετε-κωδικούς-qr",
    "hoe-qr-codes-gebruiken"
  ),
  "/shared-photo-album": route(
    "album-photo-partage",
    "album-fotografico-condiviso",
    "album-fotos-compartido",
    "album-fotos-partilhado",
    "κοινόχρηστο-άλμπουμ-φωτογραφιών",
    "gedeeld-fotoalbum"
  ),
  "/blog/what-does-a-wedding-photographer-cost": route(
    "blog/prix-photographe-mariage",
    "blog/costo-fotografo-matrimonio",
    "blog/precio-fotografo-boda",
    "blog/preco-fotografo-casamento",
    "blog/κόστος-φωτογράφου-γάμου",
    "blog/kosten-trouwfotograaf"
  ),
  "/blog/wedding-day-schedule": route(
    "blog/planning-journee-mariage",
    "blog/programma-giornata-matrimonio",
    "blog/cronograma-dia-boda",
    "blog/cronograma-dia-casamento",
    "blog/πρόγραμμα-ημέρας-γάμου",
    "blog/dagplanning-bruiloft"
  ),
  "/blog/wedding-traditions": route(
    "blog/traditions-mariage",
    "blog/tradizioni-matrimonio",
    "blog/tradiciones-boda",
    "blog/tradicoes-casamento",
    "blog/παραδόσεις-γάμου",
    "blog/bruiloftstradities"
  ),
  "/blog/municipality-wedding": route(
    "blog/mariage-mairie",
    "blog/matrimonio-civile-comune",
    "blog/boda-ayuntamiento",
    "blog/casamento-civil",
    "blog/πολιτικός-γάμος",
    "blog/trouwen-gemeentehuis"
  ),
  "/blog/julefrokost-games": route(
    "blog/jeux-fete-noel",
    "blog/giochi-festa-natale",
    "blog/juegos-fiesta-navidad",
    "blog/jogos-festa-natal",
    "blog/παιχνίδια-χριστουγεννιάτικου-πάρτι",
    "blog/kerstfeest-spellen"
  ),
  "/blog/julefrokost-entertainment": route(
    "blog/animations-fete-noel",
    "blog/intrattenimento-festa-natale",
    "blog/entretenimiento-fiesta-navidad",
    "blog/entretenimento-festa-natal",
    "blog/διασκέδαση-χριστουγεννιάτικου-πάρτι",
    "blog/kerstfeest-entertainment"
  ),
  "/blog/julefrokost-ideas": route(
    "blog/idees-fete-noel",
    "blog/idee-festa-natale",
    "blog/ideas-fiesta-navidad",
    "blog/ideias-festa-natal",
    "blog/ιδέες-χριστουγεννιάτικου-πάρτι",
    "blog/kerstfeest-ideeen"
  ),
  "/julefrokost": route(
    "fete-de-noel",
    "festa-di-natale",
    "fiesta-de-navidad",
    "festa-de-natal",
    "χριστουγεννιάτικο-πάρτι",
    "kerstfeest"
  ),
  "/konfirmation": route(
    "confirmation",
    "cresima",
    "confirmacion",
    "crisma",
    "χρίσμα",
    "vormsel"
  ),
  "/photowall": route(
    "mur-de-photos",
    "parete-fotografica",
    "muro-de-fotos",
    "mural-de-fotos",
    "τοίχος-φωτογραφιών",
    "fotomuur"
  ),
  "/blog/konfirmation-ideas": route(
    "blog/idees-confirmation",
    "blog/idee-cresima",
    "blog/ideas-confirmacion",
    "blog/ideias-crisma",
    "blog/ιδέες-για-χρίσμα",
    "blog/ideeen-vormsel"
  ),
  "/blog/konfirmationsfotografering": route(
    "blog/photographie-confirmation",
    "blog/fotografia-cresima",
    "blog/fotografia-confirmacion",
    "blog/fotografia-crisma",
    "blog/φωτογράφιση-χρίσματος",
    "blog/fotografie-vormsel"
  ),
  "/blog/konfirmationsunderholdning": route(
    "blog/animations-confirmation",
    "blog/intrattenimento-cresima",
    "blog/entretenimiento-confirmacion",
    "blog/entretenimento-crisma",
    "blog/διασκέδαση-για-χρίσμα",
    "blog/entertainment-vormsel"
  ),
  "/blog/konfirmationsdekoration-borddaekning": route(
    "blog/decoration-table-confirmation",
    "blog/decorazioni-tavola-cresima",
    "blog/decoracion-mesa-confirmacion",
    "blog/decoracao-mesa-crisma",
    "blog/διακόσμηση-τραπεζιού-χρίσματος",
    "blog/decoratie-tafel-vormsel"
  ),
  "/blog/konfirmationsindbydelser-takkekort": route(
    "blog/invitations-remerciements-confirmation",
    "blog/inviti-ringraziamenti-cresima",
    "blog/invitaciones-agradecimientos-confirmacion",
    "blog/convites-agradecimentos-crisma",
    "blog/προσκλητήρια-ευχαριστήριες-κάρτες-χρίσματος",
    "blog/uitnodigingen-bedankkaarten-vormsel"
  ),
  "/blog/konfirmationsfest-program-taler": route(
    "blog/programme-discours-fete-confirmation",
    "blog/programma-discorsi-festa-cresima",
    "blog/programa-discursos-fiesta-confirmacion",
    "blog/programa-discursos-festa-crisma",
    "blog/πρόγραμμα-ομιλίες-γιορτής-χρίσματος",
    "blog/programma-toespraken-vormselfeest"
  ),
  "/blog/konfirmation-gifts": route(
    "blog/cadeaux-confirmation",
    "blog/regali-cresima",
    "blog/regalos-confirmacion",
    "blog/presentes-crisma",
    "blog/δώρα-χρίσματος",
    "blog/cadeaus-vormsel"
  ),
  "/blog/konfirmation-food": route(
    "blog/repas-confirmation",
    "blog/cibo-cresima",
    "blog/comida-confirmacion",
    "blog/comida-crisma",
    "blog/φαγητό-χρίσματος",
    "blog/eten-vormsel"
  ),
  "/blog/konfirmation-music": route(
    "blog/musique-confirmation",
    "blog/musica-cresima",
    "blog/musica-confirmacion",
    "blog/musica-crisma",
    "blog/μουσική-χρίσματος",
    "blog/muziek-vormsel"
  ),
  "/blog/konfirmation-venue": route(
    "blog/lieu-confirmation",
    "blog/location-cresima",
    "blog/lugar-confirmacion",
    "blog/local-crisma",
    "blog/χώρος-χρίσματος",
    "blog/locatie-vormsel"
  ),
  "/blog/konfirmation-outfit": route(
    "blog/tenue-confirmation",
    "blog/abito-cresima",
    "blog/vestimenta-confirmacion",
    "blog/roupa-crisma",
    "blog/ρούχα-χρίσματος",
    "blog/kleding-vormsel"
  ),
  "/blog/christening-ideas": route(
    "blog/idees-bapteme",
    "blog/idee-battesimo",
    "blog/ideas-bautizo",
    "blog/ideias-batizado",
    "blog/ιδέες-βάπτισης",
    "blog/ideeen-doopfeest"
  ),
  "/blog/christening-food": route(
    "blog/repas-bapteme",
    "blog/cibo-battesimo",
    "blog/comida-bautizo",
    "blog/comida-batizado",
    "blog/φαγητό-βάπτισης",
    "blog/eten-doopfeest"
  ),
  "/blog/christening-gifts": route(
    "blog/cadeaux-bapteme",
    "blog/regali-battesimo",
    "blog/regalos-bautizo",
    "blog/presentes-batizado",
    "blog/δώρα-βάπτισης",
    "blog/cadeaus-doopfeest"
  ),
  "/blog/christening-decoration": route(
    "blog/decoration-bapteme",
    "blog/decorazioni-battesimo",
    "blog/decoracion-bautizo",
    "blog/decoracao-batizado",
    "blog/διακόσμηση-βάπτισης",
    "blog/decoratie-doopfeest"
  ),
  "/blog/christening-photos": route(
    "blog/photos-bapteme",
    "blog/foto-battesimo",
    "blog/fotos-bautizo",
    "blog/fotos-batizado",
    "blog/φωτογραφίες-βάπτισης",
    "blog/fotos-doopfeest"
  ),
  "/blog/wedding-speech": route(
    "blog/discours-mariage",
    "blog/discorso-matrimonio",
    "blog/discurso-boda",
    "blog/discurso-casamento",
    "blog/ομιλία-γάμου",
    "blog/bruiloftstoespraak"
  ),
  "/blog/wedding-food": route(
    "blog/repas-mariage",
    "blog/menu-matrimonio",
    "blog/comida-boda",
    "blog/comida-casamento",
    "blog/φαγητό-γάμου",
    "blog/eten-bruiloft"
  ),
  "/blog/wedding-venue": route(
    "blog/lieu-mariage",
    "blog/location-matrimonio",
    "blog/lugar-boda",
    "blog/local-casamento",
    "blog/χώρος-γάμου",
    "blog/trouwlocatie"
  ),
  "/blog/wedding-flowers": route(
    "blog/fleurs-mariage",
    "blog/fiori-matrimonio",
    "blog/flores-boda",
    "blog/flores-casamento",
    "blog/λουλούδια-γάμου",
    "blog/bruiloftsbloemen"
  ),
  "/blog/wedding-gifts": route(
    "blog/cadeaux-mariage",
    "blog/regali-matrimonio",
    "blog/regalos-boda",
    "blog/presentes-casamento",
    "blog/δώρα-γάμου",
    "blog/bruiloftscadeaus"
  ),
  "/blog/bar-mitzvah-party": route(
    "blog/fete-bar-mitsva",
    "blog/festa-bar-mitzvah",
    "blog/fiesta-bar-mitzva",
    "blog/festa-bar-mitzvah",
    "blog/γιορτή-μπαρ-μίτσβα",
    "blog/bar-mitswa-feest"
  ),
  "/blog/bar-mitzvah-food": route(
    "blog/repas-bar-mitsva",
    "blog/cibo-bar-mitzvah",
    "blog/comida-bar-mitzva",
    "blog/comida-bar-mitzvah",
    "blog/φαγητό-μπαρ-μίτσβα",
    "blog/eten-bar-mitswa"
  ),
  "/blog/bar-mitzvah-gifts": route(
    "blog/cadeaux-bar-mitsva",
    "blog/regali-bar-mitzvah",
    "blog/regalos-bar-mitzva",
    "blog/presentes-bar-mitzvah",
    "blog/δώρα-μπαρ-μίτσβα",
    "blog/cadeaus-bar-mitswa"
  ),
  "/blog/bar-mitzvah-decoration": route(
    "blog/decoration-bar-mitsva",
    "blog/decorazioni-bar-mitzvah",
    "blog/decoracion-bar-mitzva",
    "blog/decoracao-bar-mitzvah",
    "blog/διακόσμηση-μπαρ-μίτσβα",
    "blog/decoratie-bar-mitswa"
  ),
  "/blog/bar-mitzvah-photos": route(
    "blog/photos-bar-mitsva",
    "blog/foto-bar-mitzvah",
    "blog/fotos-bar-mitzva",
    "blog/fotos-bar-mitzvah",
    "blog/φωτογραφίες-μπαρ-μίτσβα",
    "blog/fotos-bar-mitswa"
  ),
  "/blog/birthday-30": route(
    "blog/anniversaire-30-ans",
    "blog/compleanno-30-anni",
    "blog/cumpleanos-30-anos",
    "blog/aniversario-30-anos",
    "blog/γενέθλια-30-ετών",
    "blog/30e-verjaardag"
  ),
  "/blog/birthday-40": route(
    "blog/anniversaire-40-ans",
    "blog/compleanno-40-anni",
    "blog/cumpleanos-40-anos",
    "blog/aniversario-40-anos",
    "blog/γενέθλια-40-ετών",
    "blog/40e-verjaardag"
  ),
  "/blog/birthday-50": route(
    "blog/anniversaire-50-ans",
    "blog/compleanno-50-anni",
    "blog/cumpleanos-50-anos",
    "blog/aniversario-50-anos",
    "blog/γενέθλια-50-ετών",
    "blog/50e-verjaardag"
  ),
  "/blog/birthday-60": route(
    "blog/anniversaire-60-ans",
    "blog/compleanno-60-anni",
    "blog/cumpleanos-60-anos",
    "blog/aniversario-60-anos",
    "blog/γενέθλια-60-ετών",
    "blog/60e-verjaardag"
  ),
  "/blog/birthday-milestone": route(
    "blog/anniversaire-marquant",
    "blog/compleanno-importante",
    "blog/cumpleanos-especial",
    "blog/aniversario-marcante",
    "blog/γενέθλια-ορόσημο",
    "blog/mijlpaal-verjaardag"
  ),
  "/barnedab": route("bapteme", "battesimo", "bautizo", "batizado", "βάπτιση", "doopfeest"),
  "/bar-mitsva": route("bar-mitsva", "bar-mitzvah", "bar-mitzva", "bar-mitzvah", "μπαρ-μίτσβα", "bar-mitswa"),
  "/fodselsdag": route("anniversaire", "compleanno", "cumpleanos", "aniversario", "γενέθλια", "verjaardag"),
};

const eventSlugs = {
  wedding: route("mariage", "matrimonio", "boda", "casamento", "γάμος", "bruiloft"),
  birthday: route("anniversaire", "compleanno", "cumpleanos", "aniversario", "γενέθλια", "verjaardag"),
  "bar-mitzvah": route("bar-mitsva", "bar-mitzvah", "bar-mitzva", "bar-mitzvah", "μπαρ-μίτσβα", "bar-mitswa"),
  christening: route("bapteme", "battesimo", "bautizo", "batizado", "βάπτιση", "doopfeest"),
  konfirmation: route("confirmation", "cresima", "confirmacion", "crisma", "χρίσμα", "vormsel"),
} as const;

const featureSlugs = {
  photowall: route("mur-de-photos", "parete-fotografica", "muro-de-fotos", "mural-de-fotos", "τοίχος-φωτογραφιών", "fotomuur"),
  "qr-code": route("code-qr", "codice-qr", "codigo-qr", "codigo-qr", "κωδικός-qr", "qr-code"),
  "full-quality-uploads": route("photos-qualite-originale", "foto-qualita-originale", "fotos-calidad-original", "fotos-qualidade-original", "φωτογραφίες-πλήρους-ποιότητας", "fotos-originele-kwaliteit"),
  "faster-uploads": route("partage-photos-rapide", "caricamento-foto-veloce", "subida-fotos-rapida", "carregamento-fotos-rapido", "γρήγορη-μεταφόρτωση-φωτογραφιών", "fotos-snel-uploaden"),
  "case-story": route("temoignage", "storia-cliente", "caso-cliente", "historia-cliente", "ιστορία-πελάτη", "klantverhaal"),
} as const;

for (const [eventKey, localizedEvents] of Object.entries(eventSlugs)) {
  for (const [featureKey, localizedFeatures] of Object.entries(featureSlugs)) {
    const pathname = `/blog/${eventKey}-${featureKey}`;
    pathnames[pathname] = Object.fromEntries(
      (Object.keys(localizedEvents) as NewLocale[]).map((locale) => [
        locale,
        `/blog/${localizedEvents[locale].slice(1)}-${localizedFeatures[locale].slice(1)}`,
      ])
    ) as LocalePaths;
  }
}

export const additionalLocalizedPathnames = pathnames;
